import React from 'react';
import './Careers.css';

const Careers = () => {
  return (
    <div className="careers-page">
      <div className="container">
        <h1>Careers</h1>
        
        <section className="careers-intro">
          <img 
            src="https://images.unsplash.com/photo-1556157382-97eda2d62296?w=800&h=400&fit=crop" 
            alt="Professional legal team" 
            className="intro-image"
          />
          <p>
            Join our dynamic team of legal professionals at  Yadi Legal Services. We are always 
            looking for talented individuals who share our commitment to excellence and 
            client service. Build your career with us in a supportive and growth-oriented environment.
          </p>
        </section>

        <section className="why-join-us">
          <h2>Why Join  Yadi Legal Services?</h2>
          <div className="grid-container">
            <div className="benefit-card">
              <h3>Professional Growth</h3>
              <p>Opportunities for continuous learning and career advancement</p>
            </div>
            <div className="benefit-card">
              <h3>Diverse Practice</h3>
              <p>Exposure to various areas of law and complex legal matters</p>
            </div>
            <div className="benefit-card">
              <h3>Mentorship</h3>
              <p>Guidance from experienced senior advocates and legal experts</p>
            </div>
            <div className="benefit-card">
              <h3>Work-Life Balance</h3>
              <p>Supportive environment that values both professional and personal well-being</p>
            </div>
          </div>
        </section>

        <section className="current-openings">
          <h2>Current Openings</h2>
          
          <div className="job-listing">
            <h3>Junior Associate</h3>
            <div className="job-details">
              <p><strong>Experience:</strong> 1-3 years</p>
              <p><strong>Areas:</strong> Civil Law, Criminal Law</p>
              <p><strong>Requirements:</strong> LLB degree, strong research skills, court experience preferred</p>
            </div>
          </div>

          <div className="job-listing">
            <h3>Senior Associate</h3>
            <div className="job-details">
              <p><strong>Experience:</strong> 5-8 years</p>
              <p><strong>Areas:</strong> Constitutional law, Corporate Law, Commercial Litigation</p>
<p>
  <strong>Requirements:</strong> 
   LLB degree, strong academic background, extensive litigation experience, and excellent client management skills.
</p>
            </div>
          </div>

          <div className="job-listing">
            <h3>Legal Research Assistant</h3>
            <div className="job-details">
              <p><strong>Experience:</strong> Fresh graduates welcome</p>
              <p><strong>Areas:</strong> Legal Research, Documentation</p>
              <p><strong>Requirements:</strong> LLB degree, excellent writing skills, attention to detail</p>
            </div>
          </div>

         
        </section>

        <section className="application-requirements">
          <h2>Application Requirements</h2>
          <ul className="requirements-list">
            <li>Updated resume with relevant experience</li>
            <li>Cover letter explaining your interest</li>
            <li>Academic transcripts and certificates</li>
            <li>Portfolio of legal work (if applicable)</li>
            <li>References from previous employers or faculty</li>
          </ul>
        </section>

        <section className="application-process">
          <h2>Application Process</h2>
          <ol className="process-steps">
            <li>Submit your application with required documents</li>
            <li>Initial screening and review</li>
            <li>Written assessment (if applicable)</li>
            <li>Personal interview with senior partners</li>
            <li>Reference verification</li>
            <li>Job offer and onboarding</li>
          </ol>
        </section>

      

        <section className="apply-section">
  <h2>Join Our Legal Team</h2>

  <p>
    If you are interested in joining our team, please contact us directly to learn more about current opportunities.
  </p>

  <div className="apply-contact">
    <p><strong>📧 Email:</strong> yadishwarn.advocate@gmail.com</p>
    <p><strong>📞 Phone:</strong> +91 9398604124</p>
  </div>
</section>
      </div>
    </div>
  );
};

export default Careers;
